module.exports = __webpack_public_path__ + "static/media/icon-contencion.0ed4b7d5.svg";